export const Globe = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <g clip-path="url(#clip0_1943_32515)">
                <path d="M14.6663 7.99792C14.6663 11.6798 11.6816 14.6646 7.99967 14.6646M14.6663 7.99792C14.6663 4.31602 11.6816 1.33125 7.99967 1.33125M14.6663 7.99792H1.33301M7.99967 14.6646C4.31778 14.6646 1.33301 11.6798 1.33301 7.99792M7.99967 14.6646C6.28783 12.8671 5.33301 10.4801 5.33301 7.99792C5.33301 5.51575 6.28783 3.12869 7.99967 1.33125M7.99967 14.6646C9.71152 12.8671 10.6663 10.4801 10.6663 7.99792C10.6663 5.51575 9.71152 3.12869 7.99967 1.33125M1.33301 7.99792C1.33301 4.31602 4.31778 1.33125 7.99967 1.33125" stroke="#007B9D" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs>
                <clipPath id="clip0_1943_32515">
                <rect width="16" height="16" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    );
};